import fetch from 'isomorphic-fetch';
//import notificationData from '../data/Notifications';

const API_Prefix = process.env.REACT_APP_API_PREFIX;

/**
 * @name handle getHeaders
 */
const getHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
});

/**
 * @name handle handleResponseNotOk
 * @param {*} fetch response
 */
const handleResponseNotOk = response => {
  const { status, statusText, url, ok } = response;
  const err = {
    status,
    statusText,
    url,
    ok,
  };
  throw new Error(JSON.stringify(err));
};

/**
 * @name handleAPIError
 * @param {*} response response from api
 * @desc handles HTTP errors because fetch won't
 */
const handleAPIError = error => {
  throw Error(error);
};

//get data from json
//export const getNotificationData = () => notificationData;

/**
 * @name handleAPIResponse
 * @param {*} response response from api
 * @desc handles API response
 */
const handleAPIResponse = async response => {
  if (!response.ok) {
    handleResponseNotOk(response);
  }
  return response.json();
};

// Fetch/GET data from API
export const getAPI = (url, queryparams = {}) => {
  let _url = new URL(`${API_Prefix}${url}`);
  if (queryparams) {
    _url.search = new URLSearchParams(queryparams);
  }
  return fetch(_url, {
    method: 'GET',
  })
    .then(handleAPIResponse)
    .catch(handleAPIError);
};

// Post data
export const postAPI = (url, requestPayload) =>
  fetch(`${API_Prefix}${url}`, {
    method: 'POST',
    body: JSON.stringify(requestPayload),
    headers: getHeaders(),
  }).then(handleAPIResponse);

// Put data
export const putAPI = (url, requestPayload) =>
  fetch(`${API_Prefix}${url}`, {
    method: 'PUT',
    body: JSON.stringify(requestPayload),
    headers: getHeaders(),
  }).then(handleAPIResponse);

// Delete data
export const deleteAPI = (url, requestPayload) =>
  fetch(`${API_Prefix}${url}`, {
    method: 'DELETE',
    body: JSON.stringify(requestPayload),
    headers: getHeaders(),
  }).then(handleAPIResponse);
